import React, { FC, useState } from "react";
import classNames from "classnames";
import { InView } from "react-intersection-observer";
import { Asset, Button, RichText } from "../../models";
import { MediaBlock } from "./components/media-block/MediaBlock";
import { ContentBlock } from "./components/content-block/ContentBlock";

type ItemProps = {
  _uid: string;
  title: RichText;
  text: RichText;
  button?: Button[];
  media: Asset;
};

type Props = {
  items: ItemProps[];
};

export const TwoColumnsList: FC<Props> = ({ items }) => {
  const [displayedItem, setDisplayedItem] = useState(items[0]);

  return (
    <div
      className={classNames(
        "mt-20 px-5",
        "lg:mt-25 lg:px-16",
        "xl:mt-40 xl:px-24",
      )}
    >
      <div className={classNames("xl:mx-auto xl:max-w-container")}>
        <div className={classNames("flex", "xl:gap-12")}>
          <div
            className={classNames(
              "flex flex-col gap-20",
              "xl:grow xl:basis-1/2 xl:gap-[50vh]",
            )}
          >
            {items.map((item) => (
              <div
                key={item._uid}
                className={classNames(
                  "flex flex-col items-center gap-5",
                  "lg:w-full lg:flex-row lg:gap-15",
                )}
              >
                <InView
                  className={classNames("w-full", "lg:grow lg:basis-1/2")}
                  threshold={0.49}
                  onChange={(inView) => inView && setDisplayedItem(item)}
                >
                  <InView
                    threshold={1}
                    onChange={(inView) => inView && setDisplayedItem(item)}
                  >
                    <MediaBlock media={item.media} />
                  </InView>
                </InView>

                <ContentBlock
                  className={classNames(
                    "w-full lg:grow lg:basis-1/2",
                    "xl:hidden",
                  )}
                  {...item}
                />
              </div>
            ))}
          </div>

          <div
            className={classNames("hidden", "xl:block xl:grow xl:basis-1/2")}
          >
            <div className="sticky top-[25vh]">
              <ContentBlock
                key={displayedItem._uid}
                className="xl:animate-slide-up xl:px-20"
                {...displayedItem}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
